class Sitemap extends HTMLElement {
    constructor() {
        super();
        this.toggles = this.querySelectorAll('.sitemap__toggle');
        this.toggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                const newContentTab = event.target.dataset.toggle;
                document
                    .querySelector('.sitemap__content-tab--active')
                    .classList.remove('sitemap__content-tab--active');
                document
                    .querySelector(
                        `.sitemap__content-tab[data-content-tab="${newContentTab}"]`
                    )
                    .classList.add('sitemap__content-tab--active');

                document
                    .querySelector('.sitemap__toggle--active')
                    .classList.remove('sitemap__toggle--active');
                document
                    .querySelector(
                        `.sitemap__toggle[data-toggle="${newContentTab}"]`
                    )
                    .classList.add('sitemap__toggle--active');
            });
        });
    }
}

customElements.define('sitemap-component', Sitemap);
